module.exports = __webpack_public_path__ + "img/screen-manual-18.2dbe3a51.png";